import { render, staticRenderFns } from "./email-visual-editor.vue?vue&type=template&id=27edf460&scoped=true"
import script from "./email-visual-editor.vue?vue&type=script&lang=js"
export * from "./email-visual-editor.vue?vue&type=script&lang=js"
import style0 from "./email-visual-editor.vue?vue&type=style&index=0&id=27edf460&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27edf460",
  null
  
)

export default component.exports